import React, { useState } from 'react'
import cx from 'classnames'
import dayjs from 'dayjs'
import DayjsUtils from '@date-io/dayjs'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import Button from '@material-ui/core/Button'

import { ThemeProvider } from '@material-ui/styles'
import caTheme from './caTheme'
import dealwatchTheme from './dealwatchTheme'
import trainingTheme from './trainingTheme'
import { DISPLAY_DATE_FORMAT } from 'constants/locale'

const datePickerProps = ({ selectedDate, isOpen, setIsOpen, handleChange }) => ({
  inputVariant: 'outlined',
  disableFuture: true,
  variant: 'inline',
  format: DISPLAY_DATE_FORMAT,
  value: selectedDate || null,
  InputAdornmentProps: {
    position: 'start',
    onClick: () => setIsOpen(true)
  },
  onChange: date => {
    if (date) {
      handleChange(date)
      setIsOpen(false)
    }
  },
  // Set these props to allow the calendar to be opened by clicking the text field
  KeyboardButtonProps: {
    onFocus: e => {
      setIsOpen(true)
    }
  },
  PopoverProps: {
    disableRestoreFocus: true,
    onClose: () => {
      setIsOpen(false)
    }
  },
  open: isOpen,
  views: ['year', 'month', 'date'],
  openTo: 'date'
})

const themes = {
  ca: caTheme,
  dealwatch: dealwatchTheme,
  training: trainingTheme
}

const CalenderDatePickers = ({
  fromDateSelected,
  toDateSelected,
  onHandleFromDateSelectedChange,
  onHandleToDateSelectedChange,
  onHandleButtonSubmit,
  disableSubmit = false,
  theme,
  showSubmitButton = true,
  datePickerPropOverrides = {}
}) => {
  const [isFromCalendarOpen, setIsFromCalendarOpen] = useState(false)
  const [isToCalendarOpen, setIsToCalendarOpen] = useState(false)
  const selectedTheme = themes[theme]

  return (
    <MuiPickersUtilsProvider libInstance={dayjs} utils={DayjsUtils} locale='en'>
      <ThemeProvider theme={selectedTheme}>
        <KeyboardDatePicker
          label='From'
          className='w-100 mt4 mb4'
          maxDate={toDateSelected}
          {...datePickerProps({
            selectedDate: fromDateSelected,
            isOpen: isFromCalendarOpen,
            setIsOpen: setIsFromCalendarOpen,
            handleChange: onHandleFromDateSelectedChange
          })}
          {...datePickerPropOverrides}
        />
        <KeyboardDatePicker
          label='To'
          className='w-100 mb4'
          minDate={fromDateSelected}
          {...datePickerProps({
            selectedDate: toDateSelected,
            isOpen: isToCalendarOpen,
            setIsOpen: setIsToCalendarOpen,
            handleChange: onHandleToDateSelectedChange
          })}
          {...datePickerPropOverrides}
        />
        {showSubmitButton && (
          <Button
            variant='outlined'
            className={cx('w-100 white h3', {
              'bg-medium-aquamarine ca-search-date-submit-button': !disableSubmit && theme !== 'dealwatch',
              'bg-dark-sea-green-3 dealwatch-search-date-submit-button': !disableSubmit && theme === 'dealwatch',
              'bg-twilight-grey': disableSubmit
            })}
            onClick={onHandleButtonSubmit}
            disabled={disableSubmit}
          >
            Submit
          </Button>
        )}
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  )
}

export default CalenderDatePickers
